import React from 'react';
import { Card, Button, Empty, Row, Col, Space } from 'antd';
import { Service } from '../mockData';

interface MonitoringConfigProps {
  service?: Service;
}

const MonitoringConfig: React.FC<MonitoringConfigProps> = ({ service }) => {
  return (
    <div>
      <Card title="告警规则配置">
        <Empty 
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span>
              暂无告警规则配置，点击下方按钮新建告警规则
            </span>
          }
        >
          <Button type="primary">新建告警规则</Button>
        </Empty>
      </Card>

      <Card title="可观测性平台配置" style={{ marginBottom: '24px' }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Card>
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <img 
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBmaWxsPSIjRTZENDAwIiBkPSJNMzQ2LjEgMjAzLjZjLS4zLTguOS00LjktMTYuNy0xMS44LTIxLjR2LS4xYy4xLS41LjItMS4xLjItMS42IDAtNS41LTQuNS0xMC0xMC0xMC0xLjIgMC0yLjQuMi0zLjUuNi04LjItMTAuOC0yMS4xLTE3LjgtMzUuOC0xNy44LTI0LjcgMC00NC43IDIwLTQ0LjcgNDQuNyAwIDQuMy42IDguNCAxLjcgMTIuMy0uNy0uMS0xLjQtLjEtMi4xLS4xLTEyLjQgMC0yMi41IDEwLjEtMjIuNSAyMi41IDAgMTIuNSAxMC4xIDIyLjUgMjIuNSAyMi41aDg1LjRjMTMuOCAwIDI1LTExLjIgMjUtMjVzLTExLjItMjUtMjUtMjUiLz48cGF0aCBmaWxsPSIjRjY4MjFGIiBkPSJNMjU4LjEgMjAzLjZjLS4zLTguOS00LjktMTYuNy0xMS44LTIxLjR2LS4xYy4xLS41LjItMS4xLjItMS42IDAtNS41LTQuNS0xMC0xMC0xMC0xLjIgMC0yLjQuMi0zLjUuNi04LjItMTAuOC0yMS4xLTE3LjgtMzUuOC0xNy44LTI0LjcgMC00NC43IDIwLTQ0LjcgNDQuNyAwIDQuMy42IDguNCAxLjcgMTIuMy0uNy0uMS0xLjQtLjEtMi4xLS4xLTEyLjQgMC0yMi41IDEwLjEtMjIuNSAyMi41IDAgMTIuNSAxMC4xIDIyLjUgMjIuNSAyMi41aDg1LjRjMTMuOCAwIDI1LTExLjIgMjUtMjVzLTExLjItMjUtMjUtMjUiLz48cGF0aCBmaWxsPSIjRUYyRDVFIiBkPSJNMTcwLjEgMjAzLjZjLS4zLTguOS00LjktMTYuNy0xMS44LTIxLjR2LS4xYy4xLS41LjItMS4xLjItMS42IDAtNS41LTQuNS0xMC0xMC0xMC0xLjIgMC0yLjQuMi0zLjUuNi04LjItMTAuOC0yMS4xLTE3LjgtMzUuOC0xNy44LTI0LjcgMC00NC43IDIwLTQ0LjcgNDQuNyAwIDQuMy42IDguNCAxLjcgMTIuMy0uNy0uMS0xLjQtLjEtMi4xLS4xLTEyLjQgMC0yMi41IDEwLjEtMjIuNSAyMi41IDAgMTIuNSAxMC4xIDIyLjUgMjIuNSAyMi41aDg1LjRjMTMuOCAwIDI1LTExLjIgMjUtMjVzLTExLjItMjUtMjUtMjUiLz48L3N2Zz4=" 
                  alt="Grafana Logo"
                  style={{ width: '60px', height: '60px', marginBottom: '16px' }}
                />
                <h3>Grafana</h3>
                {service?.name ? (
                  <div>
                    <p style={{ color: '#00000073', marginBottom: '16px' }}>已配置 Grafana 监控面板</p>
                    <Space>
                      <Button type="primary">查看面板</Button>
                      <Button>编辑配置</Button>
                    </Space>
                  </div>
                ) : (
                  <div>
                    <p style={{ color: '#00000073', marginBottom: '16px' }}>您尚未配置 Grafana</p>
                    <Button type="primary">配置</Button>
                  </div>
                )}
              </div>
            </Card>
          </Col>
          <Col span={24}>
            <Card>
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <img 
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PHBhdGggZmlsbD0iIzAwQkNENCIgZD0iTTMyIDJDMTUuNCAyIDIgMTUuNCAyIDMyYzAgMTYuNiAxMy40IDMwIDMwIDMwczMwLTEzLjQgMzAtMzBDNjIgMTUuNCA0OC42IDIgMzIgMnptMCA1OEMxNi41IDYwIDQgNDcuNSA0IDMyUzE2LjUgNCAzMiA0czI4IDEyLjUgMjggMjgtMTIuNSAyOC0yOCAyOHoiLz48cGF0aCBmaWxsPSIjMDBCQ0Q0IiBkPSJNMzIgMjBjLTYuNiAwLTEyIDUuNC0xMiAxMnM1LjQgMTIgMTIgMTIgMTItNS40IDEyLTEyLTUuNC0xMi0xMi0xMnptMCAyMmMtNS41IDAtMTAtNC41LTEwLTEwczQuNS0xMCAxMC0xMCAxMCA0LjUgMTAgMTAtNC41IDEwLTEwIDEweiIvPjwvc3ZnPg==" 
                  alt="Kibana Logo"
                  style={{ width: '60px', height: '60px', marginBottom: '16px' }}
                />
                <h3>Kibana</h3>
                {service?.name ? (
                  <div>
                    <p style={{ color: '#00000073', marginBottom: '16px' }}>已配置 Kibana 日志面板</p>
                    <Space>
                      <Button type="primary">查看面板</Button>
                      <Button>编辑配置</Button>
                    </Space>
                  </div>
                ) : (
                  <div>
                    <p style={{ color: '#00000073', marginBottom: '16px' }}>您尚未配置 Kibana</p>
                    <Button type="primary">配置</Button>
                  </div>
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default MonitoringConfig; 